import { render, staticRenderFns } from "./ProxyTable.vue?vue&type=template&id=8ea97944&scoped=true"
import script from "./ProxyTable.vue?vue&type=script&lang=js"
export * from "./ProxyTable.vue?vue&type=script&lang=js"
import style0 from "./ProxyTable.vue?vue&type=style&index=0&id=8ea97944&prod&scoped=true&lang=scss"
import style1 from "./ProxyTable.vue?vue&type=style&index=1&id=8ea97944&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea97944",
  null
  
)

export default component.exports